import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { hideLoader } from '../../store/app/actions';
import './error.css';

const Error = ({ message, hideLoader }) => {
  useEffect(() => {
    hideLoader();
    //eslint-disable-next-line
  }, []);
  return <div className="app-error cPos">{message}</div>;
};

const mapStateToProps = (state) => {
  return {
    message: state.app.error,
  };
};

const mapDispatchToProps = {
  hideLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(Error);
